import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// Import Firebase dependencies.
import firebase from 'firebase/app';
import 'firebase/auth';
import { FirebaseAuth } from '@firebase/auth-types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  public config: any;
  public frmSetNewPassword: UntypedFormGroup;
  public continueUrl: string;
  public resetDone: boolean;
  public code?: string;
  public message?: string;
  public requestPending: boolean;
  
  constructor(private fb: UntypedFormBuilder, private route: ActivatedRoute) {
    this.updateError(null)
    this.requestPending = false;
    this.config = environment.firebaseConfig
    this.frmSetNewPassword = this.fb.group({
        password: [null, [Validators.required]],
        confirmPassword: [null, [Validators.required]]
      });
    this.resetDone = false;
  }

  ngOnInit(): void {
    this.continueUrl = this.route.snapshot.queryParams['continueUrl'];
    console.log(this.continueUrl)
  }

  public setPassword() {
      this.updateError(null)
      const password = this.frmSetNewPassword.controls['password'].value;
      const confirmPassword = this.frmSetNewPassword.controls['confirmPassword'].value;
      const code = this.route.snapshot.queryParams['oobCode'];
      const apiKey = this.route.snapshot.queryParams['apiKey'];
      

      var strongRegex = new RegExp("^(?=.{10,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
      const auth = this.getAuth(apiKey);
      if (password !== confirmPassword) {
          this.updateError({code: "Mismatch", message: "Please make sure both passwords are the same."});
          return;
        }
      if (!strongRegex.test(password)) {
          this.updateError({code: "Weak password", message: "Please choose a stronger password which conforms with the policy below."});
      } else {
          this.requestPending = true;
          auth
          .confirmPasswordReset(code, password)
          .then(() => {
              console.log("User's password has been reset")
              this.requestPending = false;
              this.resetDone = true;
          })
          .catch(err => {
              this.requestPending = false;
              this.updateError(err)
          });
      }
      console.log(this.continueUrl)
  }

  private updateError(error: {code?: string, message?: string}) {
    this.code = error && error.code;
    this.message = error && error.message;
  }

  public getAuth(apiKey: string): FirebaseAuth {
    let auth = null;
    if (apiKey !== this.config.apiKey) {
      throw new Error('Invalid project!');
    }
    try {
      auth = firebase.app().auth();
    } catch (e) {
      const app = firebase.initializeApp(this.config, '[DEFAULT]');
      auth = app.auth();
    }
    return auth;
  }
  
}
